




export function start(detail){  //console.log('goku-dt 5>', detail)
         
      obj[detail.elem].start(detail)

}/**/




const obj = {
   
    typing:        { start: (detail)=>{     typing(detail)   }},


}




function typing(detail){//console.log('Typing on ty')  


}